export const YEAR_ONLY_FORMATS = {
  parse: {
    dateInput: 'yyyy',
  },
  display: {
    dateInput: 'yyyy',
    monthYearLabel: 'yyyy',
    dateA11yLabel: 'yyyy',
    monthYearA11yLabel: 'yyyy',
  },
};

/**
 * NP20-950: Eine Eingabe gilt nur als Jahr, wenn sie vollstaendig vierstellig ist
 * und nicht vor 1900 liegt — genau das kuendigt die Meldung personalData.validYear
 * an ("Bitte geben Sie ein gueltiges Jahr ein (ab 1900)").
 */
export const YEAR_PATTERN = /^\d{4}$/;
export const MIN_YEAR = 1900;

/** Frueheste waehlbare Jahreszahl im Kalender. */
export const MIN_YEAR_DATE = new Date(MIN_YEAR, 0, 1);

/**
 * NP20-950: Fehlt der Wert oder ist er unlesbar, muss null herauskommen.
 * `new Date(undefined)` liefert ein Invalid-Date-Objekt, und das ist fuer
 * Validators.required eine Eingabe — der Speichern-Button war damit auch bei
 * leerem Feld aktiv.
 */
export function toYearDate(value: Date | string | null | undefined): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? null : date;
}
